import { AnalyticsProductImpressionObjectException } from '../errors/analytics-error';
import Logger from '../utils/analytics-logger';
import DataObject from './data-object';
import ProductObject from './product-object';

export default class ProductImpressionObject extends DataObject {
  constructor(data) {
    super('uaevent', data);

    this.category = 'Ecommerce';
    if (data.category) {
      Logger.warn(
        `[AnalyticsProductImpressionObjectException] Category always defaults to "Ecommerce" (L'Oréal guideline), currently [${
          data.category
        }] was provided`,
        data,
        false,
      );
    }

    this.action = 'Product Impressions';
    if (data.action) {
      Logger.warn(
        `[AnalyticsProductImpressionObjectException] Action always defaults to "Product Impressions" (L'Oréal guideline), currently [${
          data.action
        }] was provided`,
        data,
        false,
      );
    }

    this.action = 'Product Impressions';
    if (data.label) {
      this.label = data.label;
    }

    if (!data.products || data.products.length === 0) {
      Logger.error(
        '[AnalyticsProductImpressionObjectException] Product(s) are required for a productImpression',
        data,
      );
      throw new AnalyticsProductImpressionObjectException(
        'Product(s) are required for a productImpression',
      );
    }
  }

  initEcommerce() {
    this.result.ecommerce = this.result.ecommerce || {};
  }

  set category(category) {
    this.result.eventCategory = this.setProperty(category, false);
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action, false);
  }

  set label(label) {
    this.result.eventLabel = this.setProperty(label, false);
  }

  set value(value) {
    this.result.eventValue = this.setProperty(value);
  }

  set currency(currency) {
    this.initEcommerce();
    this.result.ecommerce.currencyCode = this.setProperty(currency).toUpperCase();
  }

  set products(products) {
    this.initEcommerce();
    this.result.ecommerce.impressions = products.map((product) =>
      new ProductObject(product).toObject(),
    );
  }

  get products() {
    return (this.result.ecommerce && this.result.ecommerce.impressions) || [];
  }
}
